
// Material UI
import { Grid, Typography } from "@mui/material";

// Icons
import EditIcon from '@mui/icons-material/Edit';
import IconButton from '@mui/material/IconButton';
import VisibilityIcon from '@mui/icons-material/Visibility';

// Components
import { cardTypeFormat } from "../../../../../models/CashRegisterMovementEntity";
import { utils } from "../../../../../utils/utils";

const Total = ({ totals, viewTotal, viewMovements, diffValue }) => (
    <Grid container spacing={1} alignItems="center" justifyContent="flex-end">
        <Grid size={2}>
            <Typography color='primary' variant='subtitle1' component='p' style={{ textTransform: 'uppercase' }}>
                <strong>{`${totals?.name} ${totals?.type && cardTypeFormat[totals.type]}`}:</strong>
            </Typography>
        </Grid>
        <Grid size="grow">
            <Grid container spacing={1} justifyContent="flex-end">
                <Grid size="grow">
                    <Typography variant='body1' align="right">
                        {totals && totals.ingressTotal ? utils.formatMoney(totals.ingressTotal) : utils.formatMoney(0)}
                    </Typography>
                </Grid>
                <Grid size="grow">
                    <Typography variant='body1' align="right">
                        {totals && totals.egressTotal ? utils.formatMoney(totals.egressTotal) : utils.formatMoney(0)}
                    </Typography>
                </Grid>
                <Grid size="grow">
                    <Typography variant='body1' align="right">
                        {totals && totals.total ? utils.formatMoney(totals.total) : utils.formatMoney(0)}
                    </Typography>
                </Grid>
                <Grid size="grow">
                    <Typography variant='body1' align="right">
                        {utils.formatMoney(diffValue)}
                    </Typography>
                </Grid>
            </Grid>
        </Grid>
        <Grid size={2}>
            <Grid container spacing={1} justifyContent="flex-end">
                <Grid>
                    <IconButton onClick={() => viewTotal(totals)} size="large">
                        <EditIcon />
                    </IconButton>
                </Grid>
                <Grid>
                    <IconButton onClick={() => viewMovements(totals.id)} size="large">
                        <VisibilityIcon />
                    </IconButton>
                </Grid>
            </Grid>
        </Grid>
    </Grid>
)

export default Total;